module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-winter-ac329f4481d9db0ec3cf1440c47ea2bc.jpg";